module.exports = __webpack_public_path__ + "img/Stylized Sword-Haze.77a23e9e.png";